<template>
  <component :is="currentView" :active="active"></component>
</template>

<script>
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import { treeNodeSubType } from '@/constants/tree';
import WPerformanceServerAnaylsis from './server';
import WPerformanceNetdeviceAnaylsis from './netdevice';
import WPerformanceNetinterfaceAnaylsis from './netinterface';
import WPerformanceSensorAnaylsis from './sensor';
import WPerformanceDatabaseAnaylsis from './database';
import WPerformanceE2eAnaylsis from './e2e';
import WPerformanceServiceAnaylsis from './service';
import WPerformanceVirtualAnaylsis from './virtual';
import WPerformanceInstanceAnaylsis from './apm';
import WPerformanceApControllerAnaylsis from './ap-controller';
import WPerformanceWirelessApAnaylsis from './wireless-ap';

export default {
  name: 'WPerformanceNodeAnaylsis',
  components: {
    WPerformanceServerAnaylsis,
    WPerformanceNetdeviceAnaylsis,
    WPerformanceNetinterfaceAnaylsis,
    WPerformanceSensorAnaylsis,
    WPerformanceDatabaseAnaylsis,
    WPerformanceE2eAnaylsis,
    WPerformanceServiceAnaylsis,
    WPerformanceVirtualAnaylsis,
    WPerformanceInstanceAnaylsis,
    WPerformanceApControllerAnaylsis,
    WPerformanceWirelessApAnaylsis,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: {
    routingDatetimeRange() {
      return this.$store.state.performance.routingDatetimeRange;
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler(to, from) {
        if (this.currentView === null || to.treeKey !== from.treeKey) {
          // TODO: 트리 타입마다 treeKey가 같아도 다른 노드일 수 있음. 해당 부분 처리 추가 필요함.
          this.changeView();
        }
      },
    },
    routingDatetimeRange: {
      immediate: true,
      handler(to) {
        if (!isNil(to)) {
          this.$store.dispatch('setInitialDatetimeRange', to);
          this.$store.dispatch('setRoutingDatetimeRange', null);
        }
      },
    },
  },
  methods: {
    changeView() {
      if (this.selectedNode.subType === treeNodeSubType.SERVER) {
        this.currentView = WPerformanceServerAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.NETDEVICE) {
        this.currentView = WPerformanceNetdeviceAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.NETINTERFACE) {
        this.currentView = WPerformanceNetinterfaceAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.SENSOR) {
        this.currentView = WPerformanceSensorAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.DBMS) {
        this.currentView = WPerformanceDatabaseAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.E2E) {
        this.currentView = WPerformanceE2eAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.SERVICE) {
        this.currentView = WPerformanceServiceAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.VIRTUAL) {
        this.currentView = WPerformanceVirtualAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.APM) {
        this.currentView = WPerformanceInstanceAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.AP_CONTROLLER) {
        this.currentView = WPerformanceApControllerAnaylsis.name;
      } else if (this.selectedNode.subType === treeNodeSubType.WIRELESS_AP) {
        this.currentView = WPerformanceWirelessApAnaylsis.name;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/index.vue